import React from "react";
import { useTranslation } from "react-i18next";
import { CATEGORIES } from "../config";

export const CategoryChips = ({ active, onChange }) => {
  const { t } = useTranslation();
  const chips = [{ key: "all" }, ...CATEGORIES];

  return (
    <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1" data-testid="category-chips">
      {chips.map((c) => {
        const isActive = active === c.key;
        return (
          <button
            key={c.key}
            data-testid={`chip-${c.key}`}
            onClick={() => onChange(c.key)}
            className={`px-4 py-2 rounded-full whitespace-nowrap text-sm font-medium transition-colors border ${
              isActive
                ? "bg-brand text-white border-brand"
                : "bg-white text-stone-sub border-stone-border hover:border-brand hover:text-brand"
            }`}
          >
            {t(`jobs.${c.key}`)}
          </button>
        );
      })}
    </div>
  );
};
